import { render, staticRenderFns } from "./dynamic-bullet.vue?vue&type=template&id=4c5555b1&scoped=true&"
import script from "./dynamic-bullet.vue?vue&type=script&lang=js&"
export * from "./dynamic-bullet.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-bullet.vue?vue&type=style&index=0&id=4c5555b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5555b1",
  null
  
)

export default component.exports